// extracted by mini-css-extract-plugin
module.exports = {"loading-icon":"Toast_loading-icon__rD73u","rotation":"Toast_rotation__45VsV"};